import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { DecimalPipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { I18nModule } from '../../../i18n/i18n.module';
import { SharedModule } from '../../../common/shared.module';

import { ReportTableViewComponent } from './components/report-table-view/report-table-view.component';
import { ReportChartViewComponent } from './components/report-chart-view/report-chart-view.component';
import { ReportYearDropdownComponent } from './components/report-year-dropdown/report-year-dropdown.component';
import { ReportSubMenuComponent } from './components/report-sub-menu/report-sub-menu.component';
import { ReportDatatableComponent } from './components/report-datatable/report-datatable.component';

import { PaginationDirective } from '../../../common/directive/paginator.directive';
import { ReportChartsComponent } from './components/report-charts/report-charts.component';
import { CustomMatPaginatorIntl } from './custom-mat-paginator-int';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LineSeriesChartComponent } from './components/report-charts/components/line-series-chart/line-series-chart.component';
import { ReportDatatableExpandedComponent } from './components/report-datatable-expanded/report-datatable-expanded.component';
import { StackedClusterChartComponent } from './components/report-charts/components/stacked-cluster-chart/stacked-cluster-chart.component';
import { WaterfallChartComponent } from './components/report-charts/components/waterfall-chart/waterfall-chart.component';
import { ReportDatatablePropertyTransactionsComponent } from 'src/app/reports/components/reports-preview/components/reports-table/report-datatable-property-transactions/report-datatable-property-transactions.component';
import { ReportDatatableUnitTransactionsComponent } from 'src/app/reports/components/reports-preview/components/reports-table/report-datatable-unit-transactions/report-datatable-unit-transactions.component';
import { RentalUnitTableComponent } from './components/reports-table/rental-unit-table/rental-unit-table.component';
// import { ResidentialDetailTableComponent } from './components/reports-table/residential-detail-table/residential-detail-table.component';
import { RecordTypeDisplayComponent } from './components/reports-table/record-type-display/record-type-display.component';
import { RetailRentalUnitSizeComponent } from './components/reports-table/retail-rental-unit-size/retail-rental-unit-size.component';
import { RetailRentalMallWiseComponent } from './components/reports-table/retail-rent-mall-wise/retail-rent-mall-wise.component';
import { RetailUnitInPropertyComponent } from './components/reports-table/retail-unit-in-property/retail-unit-in-property.component';
import { LineChartComponent } from './components/report-charts/components/line-chart/line-chart.component';
import { LineBarChartComponent } from './components/report-charts/components/line-bar-chart/line-bar-chart.component';
import { OfficeRentalUnitSizeComponent } from './components/reports-table/office-rental-unit-size/office-rental-unit-size.component';
import { OfficeRentalPropertyComponent } from './components/reports-table/office-rental-property/office-rental-property.component';
import { ResidentialPrimeTransactionComponent } from './components/reports-table/residential-prime-transaction/residential-prime-transaction.component';
import { ResidentialPrimeLandComponent } from './components/reports-table/residential-prime-land/residential-prime-land.component';
import { ResidentialPrimeRentalComponent } from './components/reports-table/residential-prime-rental/residential-prime-rental.component';
import { ResidentialPrimeProjectComponent } from './components/reports-table/residential-prime-project/residential-prime-project.component';
import { WarehouseRentalUnitSizeComponent } from './components/reports-table/warehouse-rental-unit-size/warehouse-rental-unit-size.component';
import { OfficeInventoryNeighborhoodComponent } from './components/reports-table/office-inventory-neighborhood/office-inventory-neighborhoodcomponent';
import { OfficeInventoryPropertiesComponent } from './components/reports-table/office-inventory-properties/office-inventory-properties.component';
import { RetailInventoryPropertiesComponent } from './components/reports-table/retail-inventory-properties/retail-inventory-properties.component';
import { RetailInventoryDepartmentComponent } from './components/reports-table/retail-inventory-department/retail-inventory-department.component';
import { warehouseRentalPropertyComponent } from './components/reports-table/warehouse-rental-property/warehouse-rental-property.component';
import { RetailInventoryTenantsComponent } from './components/reports-table/retail-inventory-tenants/retail-inventory-tenants.component';
import { WarehouseInventoryNeighborhoodComponent } from './components/reports-table/warehouse-inventory-neighborhood/warehouse-inventory-neighborhoodcomponent';
import { WarehouseInventoryPropertiesComponent } from './components/reports-table/warehouse-inventory-properties/warehouse-inventory-properties.component';
import { HousevillaInventoryPropertiesComponent } from './components/reports-table/housevilla-inventory-properties/housevilla-inventory-properties.component';
import { HousevillaInventoryProjectsComponent } from './components/reports-table/housevilla-inventory-projects/housevilla-inventory-projects.component';
import { InvestmentInventoryPropertiesComponent } from './components/reports-table/investment-inventory-properties/investment-inventory-properties.component';
import { WarehouseInventoryProjectComponent } from './components/reports-table/warehouse-inventory-project/warehouse-inventory-project.component';
import { WarehouseInventoryLandpriceComponent } from './components/reports-table/warehouse-inventory-landprice/warehouse-inventory-landprice.component';
import { WarehouseInventoryPropertyTransactionComponent } from './components/reports-table/warehouse-inventory-property-transaction/warehouse-inventory-property-transaction.component';
import { ComparableChartComponent } from './components/report-charts/components/comparable-chart/comparable-chart.component';

@NgModule({
  declarations: [
    ReportTableViewComponent,
    ReportChartViewComponent,
    ReportYearDropdownComponent,
    ReportSubMenuComponent,
    ReportDatatableComponent,
    ReportDatatableExpandedComponent,
    ReportChartsComponent,
    LineSeriesChartComponent,
    StackedClusterChartComponent,
    WaterfallChartComponent,
    ReportDatatablePropertyTransactionsComponent,
    ReportDatatableUnitTransactionsComponent,
    RentalUnitTableComponent,
    // ResidentialDetailTableComponent,
    RecordTypeDisplayComponent,
    RetailRentalUnitSizeComponent,
    RetailRentalMallWiseComponent,
    RetailUnitInPropertyComponent,
    OfficeRentalUnitSizeComponent,
    OfficeRentalPropertyComponent,
    WarehouseRentalUnitSizeComponent,
    warehouseRentalPropertyComponent,
    LineChartComponent,
    LineBarChartComponent,
    ResidentialPrimeTransactionComponent,
    ResidentialPrimeLandComponent,
    ResidentialPrimeLandComponent,
    ResidentialPrimeRentalComponent,
    ResidentialPrimeProjectComponent,
    OfficeInventoryNeighborhoodComponent,
    OfficeInventoryPropertiesComponent,
    RetailInventoryPropertiesComponent,
    RetailInventoryDepartmentComponent,
    RetailInventoryTenantsComponent,
    WarehouseInventoryNeighborhoodComponent,
    WarehouseInventoryPropertiesComponent,
    HousevillaInventoryPropertiesComponent,
    HousevillaInventoryProjectsComponent,
    InvestmentInventoryPropertiesComponent,
    WarehouseInventoryProjectComponent,
    WarehouseInventoryLandpriceComponent,
    WarehouseInventoryPropertyTransactionComponent,
    ComparableChartComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    SharedModule,
    MatIconModule,
    HttpClientModule,
    MatMenuModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    PaginationDirective,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ReportTableViewComponent,
    ReportChartViewComponent,
    ReportYearDropdownComponent,
    ReportDatatableComponent,
    ReportDatatableExpandedComponent,
    ReportSubMenuComponent,
    ReportChartsComponent,
    LineSeriesChartComponent,
    StackedClusterChartComponent,
    WaterfallChartComponent,
    ReportDatatablePropertyTransactionsComponent,
    ReportDatatableUnitTransactionsComponent,
    RentalUnitTableComponent,
    // ResidentialDetailTableComponent,
    RecordTypeDisplayComponent,
    RetailRentalUnitSizeComponent,
    RetailRentalMallWiseComponent,
    RetailUnitInPropertyComponent,
    OfficeRentalUnitSizeComponent,
    OfficeRentalPropertyComponent,
    WarehouseRentalUnitSizeComponent,
    warehouseRentalPropertyComponent,
    LineChartComponent,
    LineBarChartComponent,
    ResidentialPrimeTransactionComponent,
    ResidentialPrimeLandComponent,
    ResidentialPrimeRentalComponent,
    ResidentialPrimeProjectComponent,
    OfficeInventoryNeighborhoodComponent,
    OfficeInventoryPropertiesComponent,
    RetailInventoryPropertiesComponent,
    RetailInventoryDepartmentComponent,
    RetailInventoryTenantsComponent,
    WarehouseInventoryNeighborhoodComponent,
    WarehouseInventoryPropertiesComponent,
    HousevillaInventoryPropertiesComponent,
    HousevillaInventoryProjectsComponent,
    InvestmentInventoryPropertiesComponent,
    WarehouseInventoryProjectComponent,
    WarehouseInventoryLandpriceComponent,
    WarehouseInventoryPropertyTransactionComponent,
    ComparableChartComponent
  ],
  providers: [
    DecimalPipe,
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl
    }
  ]
})

export class ReportsPreviewModule { }
